export const SETTINGS_LOADING = "SETTINGS_LOADING";
export const SETTINGS_FAILURE = "SETTINGS_FAILURE";
export const SETTINGS_SUCCESS = "SETTINGS_SUCCESS";

export type SettingsType = {
  vehicles: Array<Settings>;
};

export type Settings = {
  DCM: string;
  AssetNumber: string;
  VIN: string;
  DCMFirmwareVersion: string;
  MCUFirmwareVersion: string;
};

export interface SettingsLoading {
  type: typeof SETTINGS_LOADING;
}

export interface SettingsFailure {
  type: typeof SETTINGS_FAILURE;
}

export interface SettingsSuccess {
  type: typeof SETTINGS_SUCCESS;
  payload: Array<Settings>;
}

export type SettingsDispatchTypes =
  | SettingsLoading
  | SettingsFailure
  | SettingsSuccess;
